var render = function render(){
  var _vm$sheet, _vm$sheet2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-card', {
    staticClass: "w100"
  }, [_c('b-row', {
    staticClass: "sheet-title-row",
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    staticClass: "sheet-heading"
  }, [_vm.$store.getters['authenticationStorage/isAuthenticated'] ? _c('router-link', {
    staticClass: "back-link",
    attrs: {
      "to": {
        name: 'Dashboard'
      }
    }
  }, [_c('font-awesome-icon', {
    staticClass: "back-arrow",
    attrs: {
      "icon": "arrow-left",
      "color": "#101828",
      "size": "lg"
    }
  })], 1) : _vm._e(), _c('h1', {
    staticClass: "event-name"
  }, [_vm._v(" " + _vm._s((_vm$sheet = _vm.sheet) === null || _vm$sheet === void 0 ? void 0 : _vm$sheet.name) + " ")])], 1), _c('b-col', {
    staticClass: "sheet-actions-column",
    attrs: {
      "cols": "auto"
    }
  }, [_vm.$store.getters['authenticationStorage/isAuthenticated'] ? _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.invite-modal",
      modifiers: {
        "invite-modal": true
      }
    }]
  }, [_vm._v(" " + _vm._s(_vm.$t('sheet.invite')) + " ")]) : _vm._e(), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "primary",
      "disabled": _vm.exportLoading
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('download-pdf');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('sheet.pdf.download')) + " ")]), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "primary",
      "disabled": _vm.exportLoading
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('download-word');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('sheet.word.download')) + " ")])], 1)], 1), _c('b-row', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('b-col', [_c('h4', [_vm._v(_vm._s((_vm$sheet2 = _vm.sheet) === null || _vm$sheet2 === void 0 ? void 0 : _vm$sheet2.eventName))])])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }